import { render, staticRenderFns } from "./RestrictedVisitorsList.vue?vue&type=template&id=2c6f6714"
import script from "./RestrictedVisitorsList.vue?vue&type=script&lang=js"
export * from "./RestrictedVisitorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports